<template>
  <div class="com-footer">
    <div class="q-py-lg">
      <div class="container">
        <div class="row q-col-gutter-y-sm q-col-gutter-md-x-lg s-align-center s-align-sm-left">
          <div class="col-24 col-lg-10 col-xl-9">

            <!-- Меню top -->
            <div class="row q-col-gutter-x-sm q-col-gutter-xl-x-lg q-col-gutter-y-md">
              <div
                  v-for="(item, index) in topItems"
                  :key="index"
                  class="col-8 s-font-md s-font-xl-lg s-text-nowrap"
              >
                <router-link v-if="item.url" :to="item.url">
                  {{ item.label }}
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-lg-1 col-xl-2"></div>

          <div class="col-24 col-lg-6 col-xl-4 q-ml-auto">
            <div class="q-mb-md text-weight-bold s-font-sm">
              В социальных сетях
            </div>

            <div
                v-if="bottomSocialItems.length > 0"
                class="flex justify-center justify-md-start q-gutter-x-sm"
            >
              <q-btn
                  v-for="(item, index) in bottomSocialItems"
                  :key="index"
                  v-bind="menuItemToButton(item)"
                  label=""
                  class="q-pa-sm"
                  color="primary-brown-gray-1"
                  dense
                  size="12px"
                  text-color="dark"
                  unelevated
                  type="a"
                  target="_blank"
              />
            </div>

            <div class="q-mt-md">
              <div
                  v-for="(item, index) in bottomContactItems"
                  :key="index"
                  class="s-font-md s-font-xl-lg q-mb-sm"
              >
                <a v-if="item.url" :href="item.url" target="_blank">
                  {{ item.label }}
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-xl-6 text-right">
            <div>Суши-Студио © 2010-{{ currentYear }}</div>
            <div class="q-mt-sm">
              <router-link to="/sitemap" class="c-info-link">Карта сайта</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {useMenuStore} from '@/modules/menu/store/menu'
import {storeToRefs} from 'pinia'
import {menuItemToButton} from "@/core/util/project/menuItemToButton";

const menuStore = useMenuStore()
const {menuItems} = storeToRefs(menuStore)

const topItems = computed(() => menuItems.value['top'] || [])
const bottomSocialItems = computed(() => menuItems.value['bottom_social'] || [])
const bottomContactItems = computed(() => menuItems.value['bottom_contact'] || [])

const currentYear = new Date().getFullYear()

</script>

<style lang="scss" scoped>

.com-footer {
  background: #434b51;
  color: #fff;

  a {
    color: #fff;
  }
}

.c-info-copyright {
  font-size: 19px;
  line-height: 1;
}

.c-info-desc {
  color: rgba(255, 255, 255, .72);
  font-size: 13px;
}

.c-info-link {

}

.c-menu {

  .c-menu-header {
    color: rgba(255, 255, 255, .5);
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .5px;
    margin: 0 0 10px 0;
  }

  .c-menu-items {
    padding: 0;
    margin: 0;
    list-style-type: none;

    li {
      font-size: 17px;
      margin: 0 0 5px 0;

      a {
        text-decoration: none;
      }
    }
  }
}

.mobile-app-link {
  background-color: #474747;
  border-radius: 0.4rem;
  display: inline-block;
  border: 1px solid #eee;
  line-height: 0;
  width: 150px;

  img {
    width: 100%;
    box-sizing: border-box;
  }
}

.footer_link_category {
  width: 75%;
  margin: 0 auto;
  padding: 0 0 10px 0;
  display: inline-flex;
  flex-wrap: nowrap;
}

.footer_link_category div {
  padding: 10px 0 15px 0;
  gap: 15px;
  display: flex;
  width: 25%;
}

</style>
